import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

// Each entry: { start, end (inclusive, YYYY-MM-DD), item: 'type-id' }
// item is the same format PinnedCard already understands: 'post-<id>' or 'project-<id>'.
// Dates are compared as UTC calendar dates; ISO strings sort lexically, so plain
// string comparison is exact and avoids timezone edge cases.
export const SCHEDULE = [
    { start: '2026-08-01', end: '2026-09-30', item: 'project-9419' },     // project-8915
    { start: '2026-10-01', end: '2026-10-31', item: 'post-3414' },         // 
    { start: '2026-11-01', end: '2026-12-31', item: 'project-9392' },     // project-8915

];

// Shown when no scheduled entry covers today. Set to a 'type-id' string, or null to show nothing.
export const DEFAULT_ITEM = 'post-1790';

export function getActivePinnedItem() {
    const today = dayjs().utc().format('YYYY-MM-DD');
    const active = SCHEDULE.find(e => e.start <= today && today <= e.end);
    return (active && active.item) || DEFAULT_ITEM || null;
}
